// Import Bootstrap JavaScript
import bootstrap from 'bootstrap'

// Import global SCSS styles
import '../scss/main.scss';

// Import custom modules
import initEmailAddress from "./modules/init_email_address";
import initFixedMenu from "./modules/init_fixed_menu";
import initBanner from "./modules/ks-banner";
import initCardSlider from "./modules/ks-card-slider";
import initCodes from "./modules/ks-codes";
import initContactForm from "./modules/ks-contact-form";
import initCounter from "./modules/ks-counter";
import initGallery from "./modules/ks-gallery";
import initLogoSlider from "./modules/ks-logo-slider";
import initNews from "./modules/ks-news";
import initTabsMedia from "./modules/ks-tabs-media";
import initTextMedia from "./modules/ks-text-media";
import initWhitepaperList from "./modules/ks-whitepaper-list";

// Example for using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

// Initialize modules when DOM is ready
window.addEventListener('DOMContentLoaded', () => {
    initEmailAddress('.ks-email');
    initFixedMenu();
    initBanner();
    initCardSlider();
    initCodes();
    initContactForm();
    initCounter();
    initGallery();
    initLogoSlider();
    initNews();
    initTabsMedia();
    initTextMedia();
    initWhitepaperList();
});
